module.exports = __webpack_public_path__ + "img/logo.faacbb34.png";